// src/services/permissionParser.ts

export function parseRoleData(role: any) {
  if (!role?.roleMenus) {
    return {
      menus: [],
      actionIds: [],
      actionCodes: [],
    };
  }

  const menus: any[] = [];
  const actionIds: number[] = [];
  const actionCodes: string[] = [];

  role.roleMenus.forEach((rm: any) => {
    const menu = rm?.menu;
    if (!menu || menu.isHidden) return;

    menus.push(menu);

    if (Array.isArray(menu.actions)) {
      menu.actions.forEach((action: any) => {
        const hasPermission =
          Array.isArray(action.roleActions) &&
          action.roleActions.some(
            (ra: any) => ra.roleId === role.id
          );

        if (hasPermission) {
          actionIds.push(action.id);
          actionCodes.push(action.actionCode);
        }
      });
    }
  });

  return {
    menus,
    actionIds,
    actionCodes,
  };
}
